<template>
  <div>
    <v-row no-gutters>
      <v-col cols="7" class="mt-2">
        <v-text-field
          autofocus
          append-icon="mdi-barcode-scan"
          outlined
          label="Buscar Código"
          dense
          v-model="codigoproducto"
          @keyup.enter="buscarProducto"
        ></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-btn
          class="ma-2"
          outlined
          color="indigo"
          @click="showmodal = true"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row id="ticket">
      <v-col>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Descripción</th>
                <th class="text-center" width="8%">Cantidad</th>
                <th class="text-center" width="8%">Precio Compra</th>
                <th class="text-center" width="8%">Descuento</th>
                <th class="text-center" width="16%">Subtotal</th>
                <th class="text-center" width="5%"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in carrito"
                :key="item.idarticulo"
                class="text-center"
              >
                <td class="text-left">{{ item.nombre }}</td>
                <td>
                  <v-text-field
                    v-model="item.cantidad"
                    @change="calculos(item)"
                    dense
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="item.preciocompra"
                    @change="calculos(item)"
                    dense
                  ></v-text-field>
                </td>
                <td class="text-center">
                  <v-text-field
                    class="text-center"
                    v-model="item.descuento"
                    @change="calculos(item)"
                    dense
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    :value="
                      (item.cantidad * item.preciocompra - item.descuento)
                        | redondear
                    "
                    dense
                    readonly
                  ></v-text-field>
                </td>

                <td>
                  <v-btn icon @click="removeItemCart(item)" dense
                    ><v-icon color="red">mdi-close-box</v-icon></v-btn
                  >
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3"></td>
                <td style="text-align: center;">
                  <h3>Total:</h3>
                </td>
                <td style="text-align: center;">
                  <h3>{{sumatoria}}</h3>
                </td>
                <td></td>
              </tr>
              
            </tfoot>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <ModalProductos :showmodal="showmodal" :carrito="carrito" @click="showmodal=false"/>
  </div>
</template>
<script>
import currency from "@/utils/currency.js";
import ModalProductos from './ModalProductos';
export default {
  name: "TablaProductos",

  components:{
    ModalProductos
  },
  data() {
    return {
      showmodal:false,
      codigoproducto: "",
      carrito: [],
    };
  },
  methods: {
    calculos(item) {
      const index = this.carrito.indexOf(item);
      this.carrito[index].total =
        parseFloat(item.cantidad) * parseFloat(item.preciocompra) -
        parseFloat(item.descuento);

      //Validamos que el descuento no este vacio
      if (this.carrito[index].descuento.length == 0) {
        item.descuento = 0;
      }
      //Validamos que la cantidad no este vacia
      if (item.cantidad < 1) {
        item.cantidad = 1;
      }
    },
    buscarProducto() {
      const producto = this.getAllProductos.filter(
        (item) => item.codigo == this.codigoproducto
      );

      if (producto[0]) {
        this.pusCarrito(producto[0]);
      } else {
        this.infoSwal("Error", "El producto no se encontró");
      }
      this.codigoproducto = "";
    },
  },
  computed: {
    sumatoria() {
      return currency(
        this.carrito.reduce(
          (total, current) =>
            total +
            (current.cantidad * current.preciocompra - current.descuento),
          0
        )
      );
    },
  },
  filters: {
    redondear: function(value) {
      if (!value) return "";
      value = parseFloat(value);
      return currency(value, { precision: 2 });
    },
  },
};
</script>
